import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {locale} from 'primereact/api';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {RootState} from '..';
import {userPreferredLocale, userPreferredTheme} from '../../utils';

export type ThemeTypes = 'dark' | 'light';
export type LanguageOptions = 'tr' | 'en';

interface AppState {
  loading: boolean;
  theme: ThemeTypes;
  language: LanguageOptions;
}
const initialState: AppState = {
  loading: false,
  theme: userPreferredTheme as ThemeTypes,
  language: userPreferredLocale as LanguageOptions,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    showLoader: (state) => {
      state.loading = true;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
    setTheme: (state, action: PayloadAction<ThemeTypes>) => {
      state.theme = action.payload;
    },
    switchLanguage: (state, action: PayloadAction<LanguageOptions>) => {
      state.language = action.payload;
      locale(action.payload);
    },
  },
});

export const {showLoader, hideLoader, setTheme, switchLanguage} =
  appSlice.actions;

const persistConfig = {
  key: appSlice.name,
  storage,
  whitelist: ['theme', 'language'],
};

export default persistReducer(persistConfig, appSlice.reducer);

export const themeState = (state: RootState) => state.app.theme;
export const languageState = (state: RootState) => state.app.language;
